var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-cash-coin",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.438 11.944c.047.596.518 1.01 1.219 1.06V14h.562v-1.002c.728-.054 1.225-.46 1.225-1.06 0-.547-.354-.825-.996-.978l-.229-.058v-.954c.32.045.526.22.55.453h.685c-.027-.572-.515-.973-1.235-1.022V9h-.563v.387c-.652.058-1.137.464-1.137 1.044 0 .498.343.811.916.940l.221.052v1.012c-.337-.05-.557-.232-.59-.491zm1.5-2.058v-.908c.378.046.624.226.654.483h-.665zm.563 1.426.026.006c.488.115.673.245.673.519 0 .291-.231.494-.622.527v-1.052z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q-.04.183-.06.375A1 1 0 0 1 5 10V1a1 1 0 0 1 1-1zm14 5h-1.535a5 5 0 0 0-1.95-1H14a1 1 0 0 1 1 1m-3 6c.001-.002.001-.004.001-.005L12 11l.001-.005zm0-1V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4.535A5 5 0 0 0 12 10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0 1.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashCoin);
export default __webpack_public_path__ + "static/media/cash-coin.f8bbe80d839ed0032339dedabff506ab.svg";
export { ForwardRef as ReactComponent };